export const upperCase = (value) => value?.toString()?.toUpperCase() || '';

export default {
  upperCase,
};
